import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EntityContainerModel, EntityCustomContainer} from '../../../../../../models/aggregates/erp/entity';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../../shared';
import { Observable } from 'rxjs';

export class RequestBodyByGuids {
  limit: number;
  hdr_guids: string[];
}

export class RequestBodyByGuids2 {
  limit: number;
  hdr_guids: string[];
  resign_date_not_null: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends BaseApiTemplateService<EntityContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/employees';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/employees';
    this.httpClient = http;
  }

  getOwnEmployee(apiVisa: ApiVisa): Observable<ApiResponseModel<EntityContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/own';
    }
    return this.httpClient.get<ApiResponseModel<EntityContainerModel>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  getOwnCustomEmployee(apiVisa: ApiVisa): Observable<ApiResponseModel<EntityCustomContainer>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/custom-containers/own/backoffice-ep';
    }
    return this.httpClient.get<ApiResponseModel<EntityCustomContainer>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  getEmployeeByHdrGuids(body: RequestBodyByGuids, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpoint_path + '/query/snapshot-v2/backoffice-ep';
    if (apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/query/snapshot-v2/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getResignedEmployeeByHdrGuids(body: RequestBodyByGuids2, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpoint_path + '/query/snapshot-v2/backoffice-ep';
    if (apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/query/snapshot-v2/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(this.apiUrl, body, this.getHttpHeader(apiVisa));
  }

}
